var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCipa3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 431,
    height: 552,
    viewBox: "0 0 431 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.072 114.226L0.919479 138.6L47.068 94.1035L130.072 94.1035L130.072 114.226Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.994 313.041C225.61 379.226 223.225 445.425 220.855 511.61C224.073 513.751 229.128 517.729 233.121 524.293C240.016 535.64 239.096 547.044 238.622 550.922L104.601 550.922C102.288 545.723 94.2592 526.045 102.906 509.916C114.181 488.888 150.922 479.179 187.59 497.765C190.463 436.19 193.35 374.616 196.223 313.041L228.008 313.041H227.994Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.955 313.04C257.806 379.225 272.658 445.424 287.509 511.609C284.292 513.749 279.236 517.728 275.243 524.292C268.349 535.639 269.268 547.043 269.742 550.921L403.778 550.921C405.717 546.669 414.292 526.762 405.473 509.914C394.543 489.045 360.1 478.948 326.174 495.235C308.321 434.494 290.482 373.767 272.629 313.025L242.955 313.025V313.04Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.396 331.922L252.732 355.829L285.896 359.922L275.648 327.922L247.396 331.922Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.881 353.889L225.334 365.423L226.402 335.375L196.944 331.268L194.881 353.889Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.479 257.858C329.072 269.822 353.59 285.464 385.117 286.426C388.119 286.512 425.103 287.273 429.499 273.298C432.386 264.149 419.258 255.114 400.026 231.731C384.944 213.404 374.617 196.614 368.068 184.836",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.479 257.858C329.072 269.822 353.59 285.464 385.117 286.426C388.119 286.512 425.103 287.273 429.499 273.298C432.386 264.149 419.258 255.114 400.026 231.731C384.944 213.404 374.617 196.614 368.068 184.836",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.84 34.4246C327.984 48.8739 408.833 188.397 354.412 279.459C307.502 357.953 186.866 355.597 117.392 325.464C57.3115 299.395 5.63318 239.615 17.0805 218.171C25.1382 203.105 63.8754 207.959 95.2588 214.408C94.756 199.83 95.1726 182.81 97.4994 163.98C100.228 141.875 104.925 122.714 109.852 107.044C116.746 95.2379 139.54 59.6893 185.143 42.5398C190.859 40.3853 222.142 29.0528 250.825 34.4246H250.84Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M320.151 196.686H320.137C303.582 196.686 290.161 183.265 290.161 166.71L290.161 161.281C290.161 144.725 303.582 131.305 320.137 131.305H320.151C336.706 131.305 350.127 144.725 350.127 161.281V166.71C350.127 183.265 336.706 196.686 320.151 196.686Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M323.026 181.503C315.569 181.503 309.525 172.912 309.525 162.314C309.525 151.716 315.569 143.125 323.026 143.125C330.483 143.125 336.527 151.716 336.527 162.314C336.527 172.912 330.483 181.503 323.026 181.503Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M318.471 137.352L323.613 152.519L306.004 149.632L318.471 137.352Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.418 198.338H265.403C248.848 198.338 235.428 184.917 235.428 168.362L235.428 162.933C235.428 146.378 248.848 132.957 265.403 132.957H265.418C281.973 132.957 295.394 146.378 295.394 162.933V168.362C295.394 184.917 281.973 198.338 265.418 198.338Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.288 183.169C260.831 183.169 254.786 174.578 254.786 163.98C254.786 153.382 260.831 144.791 268.288 144.791C275.744 144.791 281.789 153.382 281.789 163.98C281.789 174.578 275.744 183.169 268.288 183.169Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M263.736 139.018L268.878 154.185L251.269 151.298L263.736 139.018Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.606 109.5L263.133 105.216C267.691 104.386 272.059 107.408 272.888 111.965L273.246 113.929C274.076 118.487 271.054 122.855 266.496 123.684L242.969 127.969C238.411 128.799 234.044 125.777 233.214 121.219L232.856 119.255C232.026 114.697 235.048 110.33 239.606 109.5Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M333.756 121.42L310.144 117.12C305.609 116.294 302.603 111.949 303.429 107.415L303.802 105.366C304.627 100.832 308.972 97.8255 313.507 98.6511L337.119 102.951C341.653 103.776 344.66 108.121 343.834 112.656L343.461 114.705C342.635 119.239 338.29 122.245 333.756 121.42Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.961 101.644C106.278 103.756 71.1171 109.702 33.2847 124.237C21.6219 128.719 10.8352 133.588 0.939087 138.586C1.15453 129.408 3.28024 122.198 5.99487 116.553C21.5501 84.1788 72.697 69.6003 133.711 77.6292C134.128 85.6294 134.544 93.6297 134.961 101.63V101.644Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M318.585 76.4376C296.021 17.8219 233.283 -11.4788 180.987 5.88617C138.343 20.0482 108.123 63.439 108.195 113.049C140.77 101.659 180.613 90.6139 226.69 83.6766C260.429 78.6064 291.367 76.653 318.585 76.4376Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.158 61.4566C280.404 40.6876 260.468 31.0212 247.498 36.2207C237.99 40.0413 231.455 52.1781 232.417 65.7655C249.997 64.3292 267.578 62.8929 285.158 61.4566Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M310.673 59.7754C284.59 61.7719 258.506 63.7683 232.408 65.7648C221.536 64.7881 213.823 70.5477 213.392 76.0775C213.047 80.4439 217.284 84.1064 218.376 84.9826",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1449 199.092L256.464 275.594L241.132 314.338L47.8129 237.836L63.1449 199.092Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1367 206.896L74.6877 223.199",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7334 213.346L90.2844 229.633",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.517 219.291L106.068 235.593",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.252 225.396L121.803 241.699",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M144.018 231.414L137.569 247.716",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.728 237.561L153.279 253.848",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.247 244.197L168.798 260.499",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M190.963 250.287L184.514 266.589",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.34 257.311L199.891 273.613",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M221.715 264.32L215.266 280.608",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M237.48 270.338L231.031 286.626",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.588 212.398C208.694 249.34 186.187 277.104 157.331 284.084C141.144 288.005 117.316 287.129 111.772 275.869C108.21 268.644 113.797 260.5 127.269 235.595C137.797 216.118 145.913 199.787 151.356 188.498",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M215.588 212.398C208.694 249.34 186.187 277.104 157.331 284.084C141.144 288.005 117.316 287.129 111.772 275.869C108.21 268.644 113.797 260.5 127.269 235.595C137.797 216.118 145.913 199.787 151.356 188.498",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.024 184.018C319.843 185.511 347.506 189.26 348.928 199.731C349.517 204.112 345.338 208.219 342.106 211.379C324.238 228.888 297.695 222.238 291.648 220.557",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M295.024 184.018C319.843 185.511 347.506 189.26 348.928 199.731C349.517 204.112 345.338 208.219 342.106 211.379C324.238 228.888 297.695 222.238 291.648 220.557",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.716 205.907C300.14 206.884 305.038 207.645 310.366 207.961C326.051 208.88 339.279 205.591 348.816 202.072",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipa3);
export default __webpack_public_path__ + "static/media/cipa3.42b198bb145131292895417a8dc2c0d0.svg";
export { ForwardRef as ReactComponent };